import { useEffect, useState, useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { RefContext } from "../store/RefContext";
import { Loader } from "../../../components/loader/Loader";

const tableStyle = {
  borderCollapse: "collapse",
  // border: "none",
};

const rowStyle = { height: undefined, padding: 0, border: "none" };

const headerStyle = {
  fontSize: 12,
  fontWeight: 600,
  paddingLeft: 20,
  paddingRight: 20,
  textAlign: "center",
  color: "#FFFFFF",
  backgroundColor: "#000000",
  borderLeft: "2px solid #CECECE",
};
const footerStyle = {
  fontSize: 12,
  fontWeight: 600,
  textAlign: "center",
  color: "blue",
  backgroundColor: "#F28E2B",
};
const ColumnStyle = {
  color: "#919191",
  fontSize: 12,
  fontWeight: 600,
  paddingLeft: 15,
  paddingRight: 15,
  textAlign: "center",
  borderTop: "2px solid #CECECE",
};
const BorderLeftStyle = {
  borderLeft: "2px solid #CECECE",
};
const detailStyle = {
  border: "none",
};

export const TableView = () => {
  const [lstore] = useContext(LocalStoreContext);
  const [store] = useContext(StoreContext);
  const refs = useContext(RefContext);
  const { controlPopupMenu } = store;
  const { fairvalue, loading } = lstore;

  const [filteredData1, setFilteredData1] = useState();
  const [filteredData2, setFilteredData2] = useState();
  useEffect(() => {
    if (
      fairvalue.rawdata &&
      controlPopupMenu.selected["FairValueStrike"] &&
      controlPopupMenu.selected["FairValueStrike"].length > 0
    ) {
      const filteredDataNew1 = fairvalue.rawdata.filter((item) => {
        return (
          item.Ticker === controlPopupMenu.selected["FairValue1"] &&
          controlPopupMenu.selected["FairValueStrike"].indexOf(
            item["Strike%Chg"]
          ) !== -1
        );
      });
      const filteredDataNew2 = fairvalue.rawdata.filter((item) => {
        return (
          item.Ticker === controlPopupMenu.selected["FairValue2"] &&
          controlPopupMenu.selected["FairValueStrike"].indexOf(
            item["Strike%Chg"]
          ) !== -1
        );
      });
      const filteredDataNew2Obj = filteredDataNew2.reduce((a, b) => {
        return { ...a, [b["Strike%Chg"]]: b };
      }, {});

      setFilteredData1(filteredDataNew1);
      setFilteredData2(filteredDataNew2Obj);
    }
  }, [fairvalue.rawdata, controlPopupMenu.selected]);

  if (loading) {
    return (
      <div
        style={{
          height: refs.componentSize.current["TableView"]?.height || "100%",
          width: refs.componentSize.current["TableView"]?.width - 17 || "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  if (!loading && (!fairvalue.rawdata || fairvalue.rawdata.length === 0)) {
    return (
      <div
        style={{
          height: refs.componentSize.current["TableView"]?.height || "100%",
          width: refs.componentSize.current["TableView"]?.width - 17 || "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#666",
          fontSize: 14,
        }}
      >
        No data available
      </div>
    );
  }

  return filteredData1 && filteredData2 ? (
    <div
      ref={refs.fairValue}
      style={{
        height: refs.componentSize.current["TableView"].height,
        width: refs.componentSize.current["TableView"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "inline-block", marginTop: 40 }}>
        <table style={tableStyle} className="stripes">
          <thead>
            <tr style={rowStyle}>
              <td style={detailStyle}></td>
              <td style={detailStyle}></td>
              <td style={headerStyle} colSpan={6}>
                {controlPopupMenu.selected["FairValue1"]}
              </td>
              <td style={headerStyle} colSpan={6}>
                {controlPopupMenu.selected["FairValue2"]}
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData1.map((row, i) => {
              const row2 = filteredData2[row["Strike%Chg"]];
              return (
                <tr key={"b" + i} style={rowStyle}>
                  <td
                    style={{ ...ColumnStyle, color: "#ACB6C3", paddingLeft: 5 }}
                  >
                    {row["Strike%Chg"]}
                  </td>
                  <td style={{ ...ColumnStyle, color: "#ACB6C3" }}>
                    {+row["Strike%Chg"].split("%").join("") > 0
                      ? "Call"
                      : "Put"}
                  </td>
                  <td style={{ ...ColumnStyle, ...BorderLeftStyle }}>
                    {row["Pct_1d"]}
                  </td>
                  <td style={ColumnStyle}>{row["Pct_10d"]}</td>
                  <td style={ColumnStyle}>{row["Pct_21d"]}</td>
                  <td style={ColumnStyle}>{row["Pct_63d"]}</td>
                  <td style={ColumnStyle}>{row["Pct_126d"]}</td>
                  <td style={ColumnStyle}>{row["Pct_252d"]}</td>

                  <td style={{ ...ColumnStyle, ...BorderLeftStyle }}>
                    {row2["Pct_1d"]}
                  </td>
                  <td style={ColumnStyle}>{row2["Pct_10d"]}</td>
                  <td style={ColumnStyle}>{row2["Pct_21d"]}</td>
                  <td style={ColumnStyle}>{row2["Pct_63d"]}</td>
                  <td style={ColumnStyle}>{row2["Pct_126d"]}</td>
                  <td style={ColumnStyle}>{row2["Pct_252d"]}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={rowStyle}>
              <td style={detailStyle}></td>
              <td style={detailStyle}></td>
              <td style={{ ...footerStyle, ...BorderLeftStyle }}>{"Pct_1d"}</td>
              <td style={footerStyle}>{"Pct_10d"}</td>
              <td style={footerStyle}>{"Pct_21d"}</td>
              <td style={footerStyle}>{"Pct_63d"}</td>
              <td style={footerStyle}>{"Pct_126d"}</td>
              <td style={footerStyle}>{"Pct_252d"}</td>
              <td style={{ ...footerStyle, ...BorderLeftStyle }}>{"Pct_1d"}</td>
              <td style={footerStyle}>{"Pct_10d"}</td>
              <td style={footerStyle}>{"Pct_21d"}</td>
              <td style={footerStyle}>{"Pct_63d"}</td>
              <td style={footerStyle}>{"Pct_126d"}</td>
              <td style={footerStyle}>{"Pct_252d"}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  ) : null;
};
